<template>
  <div class="avatar-box ma-1">
    <div :id="avatar.id" class="avatar-icon" data-cy="avatarIcon-avatar-image">
      <img
        :src="`https://assets.beereaders.com/avatar/${avatar.name}/${avatar.value}`"
        class="transition-all"
        id="main-avatar"
        alt="Avatar"
        height="50"
        width="50"
      />
    </div>
  </div>
</template>

<script>
const defaultAvatar = () => {
  return {
    active: false,
    avatarFormat: '',
    avatarPack: null,
    creationDate: null,
    id: 0,
    name: '',
    ordinalAvatarFormat: 1,
    value: '',
  }
}

export default {
  props: {
    avatar: {
      type: Object,
      default: defaultAvatar,
    },
  },
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    const vm = this
    this.timer = setInterval(() => {
      vm.avatarUrl()
    }, 5000)
  },
  methods: {
    avatarUrl() {
      const avatarImg = document.querySelector('#main-avatar')
      if (avatarImg)
        avatarImg.setAttribute(
          'src',
          `https://assets.beereaders.com/avatar/${this.avatar.name}/${this.avatar.value}`
        )
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="css" scoped>
/* .avatar-box {
    -webkit-box-shadow: 7px 4px 21px -4px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 7px 4px 21px -4px rgba(0, 0, 0, 0.75);
    box-shadow: 7px 4px 21px -4px rgba(0, 0, 0, 0.75);
} */
.avatar-box,
.avatar-image {
  border-radius: 500px;
  height: '40';
  width: '40';
}
/*
.avatar-icon {
    display: block;
    width: 5vw;
}
*/

/*
.avatar-box,
.avatar-image {
    border-radius: 500px;
}
*/
</style>
